import { Button, Form, Input } from 'antd';
import { FC } from 'react';

import { AppFormProps } from '@/common/interfaces';
import { defineInputStatus } from '@/common/utils';

import { SearchConsoleAccountOTPFields, SearchConsoleAccountOTPInputs } from '@/modules/DomainsApi';

interface Props extends AppFormProps<typeof SearchConsoleAccountOTPInputs, SearchConsoleAccountOTPFields> {
  isButtonsDisabled: boolean;
}

export const SearchConsoleAccountOTPFormView: FC<Props> = ({
  isButtonsDisabled,
  form,
  initialValues,
  formErrors,
  formName,
  isFormLoading,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed,
}) => {
  const formOTPSecret = Form.useWatch(SearchConsoleAccountOTPInputs.Secret, form);

  const confirm = () => {
    form.submit();
  };

  return (
    <Form
      form={ form }
      name={ formName }
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
      layout="horizontal"
      style={{ width: '100%', display: 'flex', alignItems: 'flex-start', gap: 8 }}
    >
      <Form.Item
        style={{ width: '80%', margin: 0 }}
        hasFeedback
        name={ SearchConsoleAccountOTPInputs.Secret }
        help={ formErrors?.secret }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.secret) }
        rules={ validationSchema.secret }
        getValueFromEvent={ (e) => (e.target.value as string).trim().replaceAll(' ', '') }
      >
        <Input placeholder="Ключ"/>
      </Form.Item>

      <Form.Item noStyle>
        <Button
          style={{ width: '20%', margin: 0 }}
          disabled={ isButtonsDisabled }
          loading={ isButtonsDisabled }
          onClick={ formOTPSecret === initialValues.secret || !formOTPSecret ? handleBack : confirm }
        >
          OK
        </Button>
      </Form.Item>
    </Form>
  );
};
